import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { Textbox, Textarea } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";

import { AutoComplete } from "primereact/autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import addMonths from "date-fns/addMonths";
import { InputText } from "primereact/inputtext";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { TabView, TabPanel } from 'primereact/tabview';
import { Editor } from 'primereact/editor';
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";

class OP extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pno: "",
      name: "",
      nameSuggestions: null,
      nameList: [],
      history: '',
      medicine: '',
      mail: '',
      nextOPDate: null,
      paymentDate: null,
      balance: 0,
      consultation: 0,
      products: 0,
      total: 0,
      paid: 0,
      payments: [],
      investigations: [],
      selectedFile: null,
      paymentmode: ""
    };

    this.handleNextOPDateChange = this.handleNextOPDateChange.bind(this);
    this.handlePaymentDateChange = this.handlePaymentDateChange.bind(this);

  }

  componentDidMount() {
    this.LoadNames();
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/patient/getNames"
      )
      .then((response) => {
        this.setState({ patientList: response.data });
        let nameData = response.data;
        nameData.forEach(function (item) {
          _nameList.push("[" + item.pno + "] " + item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter((t) => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {

    const PaymentModes = [
      { label: "Cash", value: "Cash" },
      { label: "Bank", value: "Bank" }
    ];

    return (
      <div>
        <div>
          <h3 align="center">Out Patient</h3>
        </div>
        <div className="container-fluid" >
          <div className="row p-1 border">
            <div className="col col-md-1">Patient</div>
            <div className="col col-md-4">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
              />
            </div>
            <div className="text-danger font-weight-bold col col-md-2">
              Balance : {this.formatAmount(this.state.balance)}
            </div>
          </div>
          <div className="row border">
            <div className="col col-md-12">
              <TabView>
                <TabPanel header="History & Medicine">
                  <Editor
                    style={{ height: '200px' }}
                    value={this.state.history}
                    onTextChange={(e) => this.setState({ history: e.htmlValue })}
                  />
                  <Editor
                    style={{ height: '200px' }}
                    value={this.state.medicine}
                    onTextChange={(e) => this.setState({ medicine: e.htmlValue })}
                  />
                  <div className="col col-md-6 p-1">
                    Next OP Date :&nbsp;
                    <DatePicker
                      selected={this.state.nextOPDate}
                      onChange={this.handleNextOPDateChange}
                      dateFormatCalendar={"MMM yyyy"}
                      minDate={new Date()}
                      maxDate={addMonths(new Date(), 12)}
                      showMonthYearDropdown
                      dateFormat="dd-MMM-yyyy"
                      width="300px"
                    />&nbsp;&nbsp;
                    <button
                      onClick={this.onSaveClick}
                      className="btn btn-primary btn-md mr-2"
                    >
                      Save
                    </button>
                  </div>
                </TabPanel>
                <TabPanel header="Payments">
                  <div className="row">
                    <div className="col col-md-4">
                      <div className="row p-1 border">
                        <div className="col col-md-3">
                          Date
                        </div>
                        <div className="col col-md-6">
                          <DatePicker
                            selected={this.state.paymentDate}
                            onChange={this.handlePaymentDateChange}
                            dateFormatCalendar={"MMM yyyy"}
                            minDate={subMonths(new Date(), 12)}
                            maxDate={new Date()}
                            showMonthYearDropdown
                            dateFormat="dd-MMM-yyyy"
                            width="150px"
                          />
                        </div>
                      </div>
                      <div className="row p-1 border">
                        <div className="col col-md-3">
                          Consultation
                        </div>
                        <div className="col col-md-6">
                          <InputText
                            type="text"
                            keyfilter="money"
                            value={this.state.consultation}
                            onChange={e => this.setState({ consultation: e.target.value })}
                            style={{ width: "100px" }}
                          />
                        </div>
                      </div>
                      <div className="row p-1 border">
                        <div className="col col-md-3">
                          Medicine
                        </div>
                        <div className="col col-md-6">
                          <InputText
                            type="text"
                            keyfilter="money"
                            value={this.state.products}
                            onChange={e => this.setState({ products: e.target.value })}
                            style={{ width: "100px" }}
                          />
                        </div>
                      </div>
                      <div className="row p-1 border">
                        <div className="col col-md-3">
                          Total
                        </div>
                        <div className="col col-md-6 text-danger font-weight-bold">
                          {this.getTotal()}
                        </div>
                      </div>
                      <div className="row p-1 border">
                        <div className="col col-md-3">
                          Paid
                        </div>
                        <div className="col col-md-6">
                          <InputText
                            type="text"
                            value={this.state.paid}
                            onChange={e => this.setState({ paid: e.target.value })}
                            style={{ width: "100px" }}
                          />
                        </div>
                      </div>
                      <div className="row p-1 border">
                        <div className="col col-md-3">
                          Payment Mode
                        </div>
                        <div className="col col-md-6">
                          <SelectButton
                            value={this.state.paymentmode}
                            options={PaymentModes}
                            onChange={this.onPaymentModeChange}
                            className="p-error"
                          />
                        </div>
                      </div>

                      <div className="row p-1 border">
                        <div className="col col-md-10">
                          <button
                            onClick={this.onPaymentClick}
                            className="btn btn-primary btn-md mr-2"
                          >
                            Add Payment
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-8">
                      <div className="ag-theme-blue" style={this.getHeight()}>
                        <AgGridReact
                          rowData={this.state.payments}
                          pagination={true}
                          enableSorting={true}
                          enableFilter={true}
                          onGridReady={this.onGridReady}
                          paginationAutoPageSize={true}
                        >
                          <AgGridColumn field="id" hide="true" />
                          <AgGridColumn
                            field="transactiondate"
                            headerName="Date"
                            width={100}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.dateFormatter}
                          />
                          <AgGridColumn
                            field="prevBalance"
                            headerName="Prev Bal"
                            width={100}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            field="consultation"
                            headerName="Consultation"
                            width={120}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            field="products"
                            headerName="Medicine"
                            width={100}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            field="total"
                            headerName="Total"
                            width={80}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            field="paid"
                            headerName="Paid"
                            width={80}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            field="balance"
                            headerName="Balance"
                            width={90}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            width={100}
                            cellRendererFramework={this.renderPaymentDeleteButton}
                          />
                        </AgGridReact>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header="Investigation">
                  <div className="row">
                    <div className="col col-md-7">
                      <div className="ag-theme-blue" style={this.getHeight()}>
                        <AgGridReact
                          rowData={this.state.investigations}
                          pagination={true}
                          enableSorting={true}
                          enableFilter={true}
                          onGridReady={this.onGridReady}
                          paginationAutoPageSize={true}
                        >
                          <AgGridColumn field="Id" hide="true" />
                          <AgGridColumn field="Pno" hide="true" />
                          <AgGridColumn
                            field="uploadedOn"
                            headerName="Date"
                            width={100}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.dateFormatter}
                          />
                          <AgGridColumn
                            field="fileName"
                            headerName="Name"
                            width={300}
                            sortable
                            resizable
                            filter
                            valueFormatter={this.currencyFormatter}
                          />
                          <AgGridColumn
                            width={100}
                            headerName="View"
                            cellRendererFramework={this.renderViewButton}
                          />
                          <AgGridColumn
                            width={100}
                            headerName="Delete"
                            cellRendererFramework={this.renderDeleteButton}
                          />
                        </AgGridReact>
                      </div>
                    </div>
                    <div className="col col-md-5">
                      <div className="row p-1">
                        <div className="col col-md-10">
                          <input type="file" onChange={this.fileChangedHandler} />
                          <button onClick={this.uploadHandler}>Upload</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                {/* <TabPanel header="Email">
                  <div>
                    <InputTextarea
                      rows={10}
                      cols={120}
                      value={this.state.mail}
                      onChange={e => this.setState({ mail: e.target.value })}
                      autoResize={false}
                    />
                  </div>
                  <div>
                    <button
                      onClick={this.onMailClick}
                      className="btn btn-primary btn-md mr-2"
                    >
                      Send Mail
                    </button>
                  </div>
                </TabPanel> */}
              </TabView>
            </div>

          </div>

          <Growl ref={(el) => (this.growl = el)} />
        </div>
      </div >
    );
  }

  onPaymentModeChange = e => {
    this.setState({ paymentmode: e.value });
  };

  renderViewButton = params => {
    return (
      <p>
        <a
          onClick={this.onViewClick}
          className="text-primary"
          id={params.data.id}
        >
          View
        </a>
      </p>
    );
  };

  renderDeleteButton = params => {
    return (
      <p>
        <a
          onClick={this.onDeleteClick}
          className="text-primary"
          id={params.data.id}
          pno={params.data.pno}
        >
          Delete
        </a>
      </p>
    );
  };

  renderPaymentDeleteButton = params => {
    return (
      <p>
        <a
          onClick={this.onPaymentDeleteClick}
          className="text-primary"
          id={params.data.id}
        >
          Delete
        </a>
      </p>
    );
  };

  onDeleteClick = e => {
    var res = window.confirm("Are you sure to delete ?");
    if (res == true) {
      var id = e.target.getAttribute("id");
      var pno = e.target.getAttribute("pno");

      axios
        .delete(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/investigation/" + id
        )
        .then(res => {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Invetsigation Deleted !!!"
          });
          this.LoadInvestigations(pno);
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong !!"
          });
        });
    }
  };

  onPaymentDeleteClick = e => {
    var res = window.confirm("Are you sure to delete ?");
    if (res == true) {
      var id = e.target.getAttribute("id");

      axios
        .delete(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/payment/" + id
        )
        .then(res => {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Payment Deleted !!!"
          });
          this.LoadList(this.state.pno);
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong !!"
          });
        });
    }
  };

  onViewClick = e => {
    let url = "Image.html";
    var id = e.target.getAttribute("id");

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/investigation/" + id
      )
      .then(res => {
        var image = new Image();
        image.src = "data:image/jpg;base64," + res.data.Content;

        var w = window.open(url, '_blank')
        w.document.write(image.outerHTML);
        w.document.title = res.data.FileName;
      })
      .catch(error => {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong !!"
        });
      });
  };

  fileChangedHandler = event => {
    this.setState({ selectedFile: event.target.files[0] })
  }

  uploadHandler = () => {

    if (
      this.state.pno === "" ||
      this.state.selectedFile === null
    ) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input !!"
      });
    } else {

      const formData = new FormData()
      formData.append(
        'myFile',
        this.state.selectedFile,
        this.state.selectedFile.name
      )
      var pno = this.state.pno;

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/patient/" + pno.replace("/", "-") + "/investigation/",
          formData
        )
        .then(res => {
          this.setState({ selectedFile: null });
          this.LoadInvestigations(pno);
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Investigation Uploaded !!!"
          });

        });
    }
  }

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  currencyFormatter(params) {
    var parts = params.value.toString().split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : ".00")
    );
  }

  handleNextOPDateChange(date) {
    this.setState({ nextOPDate: date });
  }

  handlePaymentDateChange(date) {
    this.setState({ paymentDate: date });
  }

  formatAmount(amt) {
    var parts = amt.toString().split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : ".00")
    );
  }

  getTotal() {
    var consultation = 0, products = 0, balance = 0;

    if (this.state.consultation !== '')
      consultation = parseInt(this.state.consultation);

    if (this.state.products !== '')
      products = parseInt(this.state.products);

    if (this.state.balance !== '')
      balance = parseInt(this.state.balance);

    var total = consultation + products + balance;
    return this.formatAmount(total);
  }

  getHeight() {
    var hgt = window.innerHeight - 275;
    return { height: hgt + "px" };
  }

  onNameSelect = (e) => {

    let p = e.value.split("] ");
    let pno = p[0].replace("[", "");

    let results = this.state.patientList.filter((t) => {
      return t.pno.toLowerCase() === pno.toLowerCase();
    })[0];
    this.setState({
      pno: pno
    });
    this.LoadList(pno);
  };

  LoadList(pno) {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/" + pno.replace("/", "-") + "/op"
      )
      .then(response => {
        var opDate =
          typeof response.data.nextOPDate === "undefined" ||
            response.data.nextOPDate === "" ||
            response.data.nextOPDate === null ||
            response.data.nextOPDate.startsWith("0001")
            ? null
            : new Date(response.data.nextOPDate);

        this.setState({
          medicine: response.data.medicine,
          history: response.data.history,
          balance: response.data.balance,
          nextOPDate: opDate,
          payments: response.data.payments
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    this.LoadInvestigations(pno);
  }

  LoadInvestigations(pno) {

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/" + pno.replace("/", "-") + "/investigation"
      )
      .then(response => {
        this.setState({
          investigations: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  onNameChange = (e) => {
    this.Clear();
    this.setState({
      name: e.value
    });
  };

  Clear() {
    this.setState({
      history: "",
      medicine: "",
      mail: "",
      payments: [],
      investigations: [],
      nextOPDate: null,
      paymentmode: ""
    });
  }

  ClearPayment() {
    this.setState({
      paymentDate: null,
      balance: 0,
      consultation: 0,
      products: 0,
      paid: 0,
      paymentmode: ""
    });
  }

  onSaveClick = e => {
    e.preventDefault();

    if (
      this.state.pno === ""
    ) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "select Patient !!"
      });
    } else {
      let obj = {
        pno: this.state.pno,
        history: this.state.history,
        medicine: this.state.medicine,
        nextOPDate: this.state.nextOPDate
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/patient/op/",
          obj
        )
        .then(res => {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Details Updated !!!"
          });

        });
    }
  };

  onMailClick = e => {
    e.preventDefault();

    if (
      this.state.pno === "" ||
      this.state.mail === ""
    ) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input !!"
      });
    } else {
      let obj = {
        pno: this.state.pno,
        mail: this.state.mail
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/mail/",
          obj
        )
        .then(res => {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Mail Sent !!!"
          });

        });
    }
  };


  onPaymentClick = e => {
    e.preventDefault();

    if (
      this.state.pno === "" ||
      this.state.paymentmode === "" ||
      this.state.paymentDate === "" ||
      this.state.paymentDate === null
    ) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: " Enter details !!"
      });
    } else {
      let obj = {
        pno: this.state.pno,
        paymentDate: this.state.paymentDate,
        balance: this.state.balance,
        consultation: this.state.consultation,
        products: this.state.products,
        paid: this.state.paid,
        paymentmode: this.state.paymentmode
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/patient/payment/",
          obj
        )
        .then(res => {
          this.ClearPayment();
          this.LoadList(this.state.pno);
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Details Updated !!!"
          });

        });
    }
  };

}

export default OP;
